module.exports = __webpack_public_path__ + "static/media/dxiconsmaterial.403ac720.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/dxiconsmaterial.woff2
// module id = 7862
// module chunks = 0